(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nc-label-card"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nc-label-viewer'))customElements.define('nc-label-viewer',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  const opener=this.querySelector('[data-nc-open]');if(!opener)return;
  const dialog=this.querySelector('dialog'),photo=this.querySelector('[data-nc-photo]'),zoom=this.querySelector('[data-nc-zoom]');
  const toggle=()=>{const active=photo.classList.toggle('is-zoomed');zoom.setAttribute('aria-pressed',String(active));};
  opener.addEventListener('click',()=>{this.previousOverflow=document.body.style.overflow;photo.src=photo.dataset.src;photo.classList.remove('is-zoomed');zoom.setAttribute('aria-pressed','false');dialog.showModal();document.body.style.overflow='hidden';this.querySelector('.nc-label-dialog__scroll').scrollTo(0,0);});
  zoom.addEventListener('click',toggle);photo.addEventListener('click',toggle);
  this.querySelector('[data-nc-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('close',()=>{document.body.style.overflow=this.previousOverflow||'';opener.focus({preventScroll:true});});
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nc-product-decision"] && !Shopify.designMode) return;
  try {
    (() => {
  const reveal = () => {
    const hash = window.location.hash;
    if (!hash || hash === '#') return;
    let target;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch { return; }
    if (!target) return;
    const details = target.matches('details.nc-deep') ? target : target.matches('.nc-deep-section') ? target.querySelector('details.nc-deep') : null;
    if (details) details.open = true;
    let ancestor = target.parentElement;
    while (ancestor) { if (ancestor.matches('details')) ancestor.open = true; ancestor = ancestor.parentElement; }
  };
  window.addEventListener('hashchange', reveal);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (link && link.hash === window.location.hash) reveal();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal, {once:true}); else reveal();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nc-sticky-purchase"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nc-sticky-purchase'))customElements.define('nc-sticky-purchase',class extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();
  this.start=()=>this.mount();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.start,{once:true,signal:this.abort.signal});else this.mount();
 }
 mount(){
  if(this.bar)return;
  const bar=document.querySelector('.tv-sticky-buy,.pv-sticky-buy,.gv-sticky-buy');
  if(!bar)return;
  const label=bar.querySelector('.tv-sticky-label,.pv-sticky-label,.gv-sticky-label');
  const add=bar.querySelector('button[type=submit]');
  const form=add?.form;
  if(!label||!form||bar.classList.contains('nc-sticky-enhanced'))return;
  this.bar=bar;this.form=form;this.add=add;
  const main=form.querySelector('.tv-add,.pv-add,.gv-add');
  const change=document.createElement('button');change.type='button';change.className='nc-sticky-change';
  const caption=document.createElement('span');caption.className='nc-sticky-caption';
  const name=document.createElement('span');name.textContent=this.dataset.name+' · ';
  const chevron=document.createElement('span');chevron.className='nc-sticky-chevron';chevron.textContent='⌃';chevron.setAttribute('aria-hidden','true');
  label.before(change);caption.append(name,label);change.append(caption,chevron);
  change.addEventListener('click',()=>{
   const target=[...form.querySelectorAll('select,[name=id]:checked,[data-pick]:checked')].find(el=>el.getClientRects().length&&!el.closest('[hidden]'));
   const area=target?.closest('fieldset,.pv-pairs')||form;
   area.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'center'});
   target?.focus({preventScroll:true});
  },{signal:this.abort.signal});
  const gift=document.createElement('span');gift.className='nc-sticky-gift';gift.hidden=true;label.closest('div').append(gift);
  const promo=form.querySelector('nc-wellous-product');
  const weights=JSON.parse(promo?.querySelector('[data-wp-weights]')?.textContent||'{}');
  this.update=()=>{
   name.hidden=label.textContent.toUpperCase().includes(this.dataset.name.split('＋')[0].toUpperCase());
   change.setAttribute('aria-label',this.dataset.change+'：'+this.dataset.name+' · '+label.textContent);
   const data=new FormData(form);const units=(weights[String(data.get('id'))]||0)*Math.max(1,Number(data.get('quantity'))||1);
   const count=Math.floor(units/6);gift.hidden=!count||!promo||Date.now()>=Date.parse(promo.dataset.end);
   const text=this.dataset.gift.replace('[gifts]',count);if(gift.textContent!==text)gift.textContent=text;
  };
  this.refresh=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(this.update);};
  this.observer=new MutationObserver(this.refresh);
  this.observer.observe(label,{childList:true,subtree:true,characterData:true});
  this.observer.observe(form,{attributes:true,subtree:true,attributeFilter:['value','checked']});
  document.addEventListener('change',this.refresh,{signal:this.abort.signal});
  document.addEventListener('input',this.refresh,{signal:this.abort.signal});
  window.addEventListener('popstate',this.refresh,{signal:this.abort.signal});
  this.pending=false;
  form.addEventListener('submit',event=>{
   if(this.pending){event.preventDefault();return;}
   if(event.defaultPrevented)return;
   this.pending=true;this.savedText=add.textContent;
   queueMicrotask(()=>{
    if(event.defaultPrevented){this.pending=false;return;}
    add.disabled=true;add.textContent=this.dataset.adding;add.setAttribute('aria-busy','true');
    if(main){this.savedMain=main.textContent;main.disabled=true;main.textContent=this.dataset.adding;}
   });
  },{signal:this.abort.signal});
  window.addEventListener('pageshow',()=>{
   if(!this.pending)return;this.pending=false;add.disabled=false;add.textContent=this.savedText;add.removeAttribute('aria-busy');
   if(main){main.disabled=false;main.textContent=this.savedMain;}this.update();
  },{signal:this.abort.signal});
  bar.classList.add('nc-sticky-enhanced');
  this.resize=new ResizeObserver(()=>{const height=bar.getBoundingClientRect().height;if(height)document.body.style.setProperty('--nc-sticky-height',Math.ceil(height)+'px');});
  this.resize.observe(bar);this.timer=setInterval(this.update,30000);this.update();
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.resize?.disconnect();clearInterval(this.timer);cancelAnimationFrame(this.frame);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nc-wellous-badge"] && !Shopify.designMode) return;
  try {
    if(!window.ncWellousExpiry){window.ncWellousExpiry=true;const update=()=>document.querySelectorAll('[data-wellous-until]').forEach(el=>{if(Date.now()>=Date.parse(el.dataset.wellousUntil))el.hidden=true;});update();setInterval(update,30000);document.addEventListener('visibilitychange',update);}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nc-wellous-product"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nc-wellous-product'))customElements.define('nc-wellous-product',class extends HTMLElement{
 connectedCallback(){this.form=this.closest('form');if(!this.form)return;this.weights=JSON.parse(this.querySelector('[data-wp-weights]').textContent);this.strings=JSON.parse(this.querySelector('[data-wp-strings]').textContent);this.abort=new AbortController();this.refresh=()=>requestAnimationFrame(()=>this.update());document.addEventListener('change',this.refresh,{signal:this.abort.signal});document.addEventListener('input',this.refresh,{signal:this.abort.signal});window.addEventListener('popstate',this.refresh,{signal:this.abort.signal});this.observer=new MutationObserver(this.refresh);this.observer.observe(this.form,{attributes:true,subtree:true,attributeFilter:['value','checked']});this.timer=setInterval(()=>this.update(),30000);this.update();}
 update(){const data=new FormData(this.form);const id=String(data.get('id')||'');const units=(this.weights[id]||0)*Math.max(1,Number(data.get('quantity'))||1);this.hidden=!units||Date.now()>=Date.parse(this.dataset.end);const gifts=Math.floor(units/6);this.querySelector('[data-wp-result]').textContent=(gifts?this.strings.earned:this.strings.offer_headline).replace('[gifts]',gifts);this.querySelector('[data-wp-qualification]').textContent=(gifts?this.strings.qualified_note:this.strings.accumulate).replace('[units]',units);}
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();clearInterval(this.timer);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["np-moveon-liveon-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
  const revealBundleDetails = () => {
    const page = document.querySelector('.nc-bundle-editorial');
    if (!page || !location.hash) return;
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    if (!target || !page.contains(target)) return;
    if (target.id === 'pv-spec' || target.id === 'pv-book') {
      target.querySelectorAll(':scope > .pv-inner > details').forEach(details => { details.open = true; });
    }
  };
  window.addEventListener('hashchange', revealBundleDetails);
  document.addEventListener('click', event => {
    const link = event.target.closest('.nc-bundle-editorial a[href^="#"]');
    if (link && link.hash === location.hash) revealBundleDetails();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealBundleDetails, { once: true });
  else revealBundleDetails();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nutricare-femoire-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('femoire-gallery')) customElements.define('femoire-gallery',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const main=this.querySelector('.ni-gallery-main'),img=main.querySelector('img'),dialog=this.querySelector('dialog');this.querySelectorAll('.ni-thumbs button').forEach(button=>button.addEventListener('click',()=>{const source=button.querySelector('img');img.src=source.src;img.alt=source.alt;this.querySelectorAll('.ni-thumbs button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));main.addEventListener('click',()=>{const target=dialog.querySelector('img');target.src=img.src;target.alt=img.alt;dialog.showModal();});dialog.querySelector('button').addEventListener('click',()=>dialog.close());}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nutricare-imuglo-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('imuglo-gallery')) customElements.define('imuglo-gallery',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const main=this.querySelector('.ni-gallery-main'),img=main.querySelector('img'),dialog=this.querySelector('dialog');this.querySelectorAll('.ni-thumbs button').forEach(button=>button.addEventListener('click',()=>{const source=button.querySelector('img');img.src=source.src;img.alt=source.alt;this.querySelectorAll('.ni-thumbs button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));main.addEventListener('click',()=>{const target=dialog.querySelector('img');target.src=img.src;target.alt=img.alt;dialog.showModal();});dialog.querySelector('button').addEventListener('click',()=>dialog.close());}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tmk-compact-summary"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nc-wellous-product'))customElements.define('nc-wellous-product',class extends HTMLElement{
 connectedCallback(){this.form=this.closest('form');if(!this.form)return;this.weights=JSON.parse(this.querySelector('[data-wp-weights]').textContent);this.strings=JSON.parse(this.querySelector('[data-wp-strings]').textContent);this.abort=new AbortController();this.refresh=()=>requestAnimationFrame(()=>this.update());document.addEventListener('change',this.refresh,{signal:this.abort.signal});document.addEventListener('input',this.refresh,{signal:this.abort.signal});window.addEventListener('popstate',this.refresh,{signal:this.abort.signal});this.observer=new MutationObserver(this.refresh);this.observer.observe(this.form,{attributes:true,subtree:true,attributeFilter:['value','checked']});this.timer=setInterval(()=>this.update(),30000);this.update();}
 update(){const data=new FormData(this.form);const id=String(data.get('id')||'');const units=(this.weights[id]||0)*Math.max(1,Number(data.get('quantity'))||1);this.hidden=!units||Date.now()>=Date.parse(this.dataset.end);const gifts=Math.floor(units/6);this.querySelector('[data-wp-result]').textContent=(gifts?this.strings.earned:this.strings.offer_headline).replace('[gifts]',gifts);this.querySelector('[data-wp-qualification]').textContent=(gifts?this.strings.qualified_note:this.strings.accumulate).replace('[units]',units);}
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();clearInterval(this.timer);}
});
  } catch(e) { console.error(e); }
})();

})();
